import { applyBasePrimeCostPrices } from "../utils/applyBasePrimeCostPrices";

function formatStickerNames(stickerNames: any): string {
  if (!stickerNames || !Array.isArray(stickerNames) || stickerNames.length === 0) {
    return "";
  }
  return stickerNames
    .map((item: any) => (item && item.name ? item.name : ""))
    .filter(Boolean)
    .join(", ");
}

export function flattenChildrenTree(
  tree: any[],
  expandedProductIds: Record<string | number, boolean> = {}
): any[] {
  const rows: any[] = [];

  (tree || []).forEach((product: any) => {
    const containers = product.children || [];
    const hasContainers = containers.length > 0;

    rows.push({
      ...product,
      type: "product",
      depth: 0,
      hasContainers,
      containerCount: containers.length
    });

    if (expandedProductIds[product.id]) {
      containers.forEach((container: any) => {
        rows.push({
          ...container,
          type: "container",
          depth: 1,
          parentProductId: product.id
        });
      });
    }
  });

  return rows;
}

// Вес тары в названии хранится текстом («0,5 кг» / «0.5 кг») — порядок
// строим по числу из названия, запасной источник — колонка weight.
const TARE_WEIGHT_IN_NAME = /(\d+(?:[.,]\d+)?)/;

function tareWeightValue(container: any): number {
  const fromName = String(container.name || "").match(TARE_WEIGHT_IN_NAME);
  if (fromName) {
    return parseFloat(fromName[1].replace(",", "."));
  }

  const weight = container.weight == null ? NaN : parseFloat(String(container.weight));
  if (Number.isFinite(weight)) {
    return weight;
  }

  return Number.POSITIVE_INFINITY;
}

function sortContainersByTareWeight(containers: any[]): any[] {
  return containers.sort((a: any, b: any) => {
    const weightA = tareWeightValue(a);
    const weightB = tareWeightValue(b);
    if (weightA !== weightB) {
      return weightA - weightB;
    }
    return String(a.name || "").localeCompare(String(b.name || ""), "ru");
  });
}

export function buildChildrenTree(documents: any[]): any[] {
  return (documents || [])
    .filter((doc: any) => !doc.archived_at)
    .map((doc: any) => {
      const allContainers = (doc.children || []).map((item: any) => ({
        ...item,
        type: "container",
        name: item.name || item.container_name || "-",
        code: item.code || item.sku_mixcart || item.code_1c || "",
        sticker: formatStickerNames(item.sticker_names),
        product_name: doc.name
      }));

      const containers = sortContainersByTareWeight(
        allContainers.filter((item: any) => !item.archived_at)
      );

      return applyBasePrimeCostPrices({
        ...doc,
        type: "product",
        name: doc.name || doc.product_name || "-",
        code: doc.code || "",
        sticker: "",
        children: containers
      });
    });
}
